<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Editar Plan Pago Universidad</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" lg="6">
            <ListadoItem nombreCampo="Nombre Plan" :valorCampo="form.nombre" />
          </v-col>

          <v-col cols="12" lg="6">
            <ListadoItem nombreCampo="Universidad" :valorCampo="form.universidad?.nombre" />
          </v-col>

          <v-col cols="12">
            <v-btn
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              @click="$refs.modalFormularioPlanPagoConceptoUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Editar"
              small
              :disabled="item == null || !item.estaActivo"
              @click="$refs.modalFormularioPlanPagoConceptoUniversidadRef.abrir(accionesCrud.EDITAR, item)">
              <v-icon>mdi-pencil</v-icon>

              Editar
            </v-btn>

            <v-btn
              class="mx-1"
              title="Cambiar Monto"
              small
              :disabled="item == null || !item.estaActivo"
              @click="$refs.modalFormularioPlanPagoConceptoUniversidadRef.abrir('cambiar-monto', item)">
              <v-icon>mdi-swap-horizontal</v-icon>

              Cambiar Monto
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoPlanesPagosConceptosUniversidades
              ref="listadoRef"
              :cargando="false"
              :items="form.planesPagosConceptosUniversidades"
              @selectItem="selectItem"
              @ordenar="guardarOrden" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>

    <ModalFormularioPlanPagoConceptoUniversidad
      ref="modalFormularioPlanPagoConceptoUniversidadRef"
      :nombreRecurso="nombreItem"
      :universidadId="form.universidadId"
      :planPagoUniversidadId="form?.id"
      @actualizarListado="cerrarActualizar"
      @agregarPlanPagoConceptoUniversidad="agregarPlanPagoConceptoUniversidad" />
  </v-dialog>
</template>

<script>
import ListadoItem from './ListadoItem.vue';
import ListadoPlanesPagosConceptosUniversidades from './ListadoPlanesPagosConceptosUniversidades.vue';
import modalFormMixin from '../mixins/modal-form.mixin';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModalFormularioPlanPagoConceptoUniversidad from './ModalFormularioPlanPagoConceptoUniversidad.vue';
import PlanPagoConceptoUniversidadService from '../services/plan-pago-concepto-universidad.service';

export default {
  name: 'ModalFormularioEditarPlanPagoUniversidad',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoItem,
    ListadoPlanesPagosConceptosUniversidades,
    ModalFormularioPlanPagoConceptoUniversidad,
  },
  data() {
    return {
      nombreItem: 'Plan Pago Concepto Universidad',
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        universidadId: null,
        universidad: null,
        planesPagosConceptosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        universidadId: data.universidadId,
        universidad: data.universidad,
        planesPagosConceptosUniversidades: data.planesPagosConceptosUniversidades,
      };
    },
    abrir(accion, data = null) {
      this.abrirMixin(accion, data);
    },
    cerrar() {
      this.visible = false;
      this.item = null;
    },
    cerrarActualizar() {
      this.cerrar();
      this.$emit('actualizarListado');
    },
    agregarPlanPagoConceptoUniversidad(planPagoConceptoUniversidad) {
      if (
        this.form.planesPagosConceptosUniversidades.findIndex(
          (plan) => plan.conceptoUniversidadId == planPagoConceptoUniversidad.conceptoUniversidadId,
        ) !== -1
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'El concepto ya se encuentra agregado.',
          type: 'error',
        });

        return;
      }

      this.form.planesPagosConceptosUniversidades.push({
        ...planPagoConceptoUniversidad,
        orden: this.form.planesPagosConceptosUniversidades.length + 1,
      });
    },
    async guardarOrden() {
      const ordenPlanes = this.form.planesPagosConceptosUniversidades.map((plan) => {
        return {
          id: plan.id,
          orden: plan.orden,
        };
      });

      await this.guardarDatosMixin(
        PlanPagoConceptoUniversidadService.order,
        () => {},
        this.accionesCrud.REGISTRAR,
        { planesPagosConceptosUniversidades: ordenPlanes },
        'Ordenar Planes Pagos Conceptos Universidades',
        () => {
          this.$notify({
            group: 'notifications',
            title: 'Éxito',
            text: 'Se ha guardado el orden correctamente.',
            type: 'success',
          });

          this.$emit('actualizarListado');
        },
        () => {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'Ha ocurrido un error al guardar el orden.',
            type: 'error',
          });
        },
      );
    },
  },
};
</script>